import { faCheckCircle, faQuestionCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Avatar, Card, CardContent, CardHeader, Chip, Divider, LinearProgress, makeStyles, MuiThemeProvider, Typography } from '@material-ui/core';
import { purple } from '@material-ui/core/colors';
import { ServiceCard } from 'components/ServiceCard';
import { mapServiceToServiceCard } from 'components/ServiceCard/ServiceCard.types';
import isEmpty from 'lodash.isempty';
import React, { useMemo } from 'react';
import voca from 'voca';
import { yiq } from 'yiq';
import Themes from "src/themes";
import { parseBookingStatus } from 'util/bookingStates';

const useStyles = makeStyles((theme) => {
  return {
    statusChip: {
      marginLeft: theme.spacing(1)
    },
    extras: {
      display: 'flex',
      flexWrap: 'wrap',
      listStyle: 'none',
      padding: theme.spacing(0.5),
      margin: 0,
    },
    extrachip: {
      margin: theme.spacing(0.5),
    },
    card: {
      backgroundColor: ({ booking }) => {
        return `#${booking?.type?.color}`
      }
    }
  }
})

const BookingType = ({ booking, loading = false }) => {
  const classes = useStyles({ booking })
  const mappedService = useMemo(() => {
    if (isEmpty(booking)) return {}
    const mappedService = mapServiceToServiceCard(
      {
        type: booking?.type,
        extended_packages: booking?.extended_packages,
        extended_package_items: booking?.extended_package_items,
        extended_services: booking?.extended_services,
        // status: booking?.status,
        scheduled_status: booking?.appointment?.status,
        mappedStatus: parseBookingStatus(booking)
      }
    )
    return mappedService
  }, [booking]);


  const renderChips = useMemo(() => {
    const chipArray = booking?.type?.extras || []
    const chips = [...chipArray].sort((a, b) => {
      const nameA = a.label.toUpperCase();
      const nameB = b.label.toUpperCase();
      if (nameA < nameB) {
        return -1;
      }
      if (nameA > nameB) {
        return 1;
      }
      return 0;
    })
    return <Typography className='body1'>{chips.map(c => c?.label).join(', ')}</Typography>
  }, [booking?.type?.extras]);

  if (isEmpty(booking)) return <></>

  return (
    <ServiceCard cardSetup={mappedService}>
      {!isEmpty(booking?.type?.extras) && (
        <CardContent classes={classes.card}>
          <div className={classes.extras}>
            {renderChips}
          </div>
        </CardContent>
      )}
    </ServiceCard>
  )
}

const WrappedCard = ({ booking, ...props }) => {
  const colorYiq = yiq(`#${booking?.type?.color ?? '000'}`, { threshold: 128 })
  const theme = colorYiq === '#000' ? Themes.dark : Themes.default
  return (
    <MuiThemeProvider theme={theme}>
      <BookingType booking={booking} {...props} />
    </MuiThemeProvider>
  )
}
export { WrappedCard as BookingType };
